/* eslint-disable max-len */

import Image from "next/image";
import Link from "next/link";

import { ROUTES } from "@/helpers/routes";
import PageSeo from "@/shared/components/PageSeo";

import Layout from "../../shared/components/layout";

export default function Newsletter() {
    const setGAnalytics = (reportName: string) => {
        gtag("event", "Download Narative", { description: reportName });
    };

    return (
        <div>
            <PageSeo title="Narratives | The Gender Index" pathname={ROUTES.reportsNarratives} />
            <Layout>
                <div className='singleLayout reportPage'>
                    <h3>TGI Reports </h3>
                    <p className='body-default-copy textCenter'>Our Annual Reports and regional narratives are free to download, read and share.
                        We hope they stimulate ideas, discussion and policy decisions to inspire positive change.</p>
                    <div className='tabsNavigation'>
                        <ul className='commonList'>
                            <li>
                                <Link href="/reports">Annual Reports</Link>
                            </li>
                            <li className='active'>
                                <Link href="/reports/narratives">Narratives</Link>
                            </li>
                        </ul>
                    </div>
                    <div className="narrativeList">
                        <ul className="commonList">
                            {/* 2026 Narrative */}
                            <li>
                                <Image
                                    src="/images/Narratives/2026/England.jpg"
                                    alt="report_cover_image_2026"
                                    width={295}
                                    height={414}
                                    loading="lazy"
                                />
                                <div className="reportDetail">
                                    <h2>England narrative 2026</h2>
                                    <p className='body-default-copy'>
                                        This report examines regional variation across England, highlighting differences in incorporation rates, access to capital, and
                                        business performance. It identifies where female-led businesses are gaining ground and where structural barriers continue to limit scale and sustainability.
                                    </p>
                                    <div className='actionBtnsWrap'>
                                        <Link href="/images/Narratives/2026/England-Report-2026.pdf" target="_blank">
                                            <button className='btn-green' onClick={() => setGAnalytics("England")}>Download narrative</button >
                                        </Link>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <Image
                                    src="/images/Narratives/2026/Scotland.jpg"
                                    alt="report_cover_image_2026"
                                    width={295}
                                    height={414}
                                    loading="lazy"
                                />
                                <div className="reportDetail">
                                    <h2>Scotland narrative 2026</h2>
                                    <p className='body-default-copy'>
                                        The Scotland narrative explores trends in company formation, leadership and growth, alongside regional disparities in funding and scale-up potential.
                                        It highlights both areas of resilience and the policy gaps that continue to constrain progress.
                                    </p>
                                    <div className='actionBtnsWrap'>
                                        <Link href="/images/Narratives/2026/Scotland-Report-2026.pdf" target="_blank">
                                            <button className='btn-green' onClick={() => setGAnalytics("Scotland")}>Download narrative</button >
                                        </Link>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <Image
                                    src="/images/Narratives/2026/Wales.jpg"
                                    alt="report_cover_image_2026"
                                    width={295}
                                    height={414}
                                    loading="lazy"
                                />
                                <div className="reportDetail">
                                    <h2>Wales narrative 2026</h2>
                                    <p className='body-default-copy'>
                                        The Wales narrative focuses on shifts in company activity, including incorporations, dissolutions and leadership trends.
                                        It also examines how regional dynamics are influencing the sustainability and growth trajectory of female-led businesses.
                                    </p>
                                    <div className='actionBtnsWrap'>
                                        <Link href="/images/Narratives/2026/Wales-Report-2026.pdf" target="_blank">
                                            <button className='btn-green' onClick={() => setGAnalytics("Wales")}>Download narrative</button >
                                        </Link>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <Image
                                    src="/images/Narratives/2026/Northern-Ireland.jpg"
                                    alt="report_cover_image_2026"
                                    width={295}
                                    height={414}
                                    loading="lazy"
                                />
                                <div className="reportDetail">
                                    <h2>Northern Ireland narrative 2026</h2>
                                    <p className='body-default-copy'>
                                        The Northern Ireland narrative provides insight into company creation, leadership composition and closures, alongside broader structural challenges.
                                        It highlights how regional constraints continue to shape outcomes for female entrepreneurs.
                                    </p>
                                    <div className='actionBtnsWrap'>
                                        <Link href="/images/Narratives/2026/Northern-Ireland-Report-2026.pdf" target="_blank">
                                            <button className='btn-green' onClick={() => setGAnalytics("Northern Ireland")}>Download narrative</button >
                                        </Link>
                                    </div>
                                </div>
                            </li>
                            {/* 2025 Narrative */}
                            <li>
                                <Image
                                    src="/images/Narratives/2025/England.png"
                                    alt="report_cover_image"
                                    width={295}
                                    height={414}
                                    loading="lazy"
                                />
                                <div className="reportDetail">
                                    <h2>England narrative 2025</h2>
                                    <p className='body-default-copy'>
                                        This report provides an overview of female-led companies in England for 2025, exploring trends in company leadership, incorporations, and dissolutions. It examines regional
                                        patterns and broader developments affecting women in business.
                                    </p>
                                    <div className='actionBtnsWrap'>
                                        <Link href="/images/Narratives/2025/England-Report-2025.pdf" target="_blank">
                                            <button className='btn-green' onClick={() => setGAnalytics("England")}>Download narrative</button >
                                        </Link>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <Image
                                    src="/images/Narratives/2025/Scotland.png"
                                    alt="report_cover_image"
                                    width={295}
                                    height={414}
                                    loading="lazy"
                                />
                                <div className="reportDetail">
                                    <h2>Scotland narrative 2025</h2>
                                    <p className='body-default-copy'>
                                        This report outlines key insights on female-led companies in Scotland for 2025, covering trends in company creation, leadership, and closures. It provides an overview of changes
                                        over time and regional variations.
                                    </p>
                                    <div className='actionBtnsWrap'>
                                        <Link href="/images/Narratives/2025/Scotland-Report-2025.pdf" target="_blank">
                                            <button className='btn-green' onClick={() => setGAnalytics("Scotland")}>Download narrative</button >
                                        </Link>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <Image
                                    src="/images/Narratives/2025/Wales.png"
                                    alt="report_cover_image"
                                    width={295}
                                    height={414}
                                    loading="lazy"
                                />
                                <div className="reportDetail">
                                    <h2>Wales narrative 2025</h2>
                                    <p className='body-default-copy'>
                                        This report examines the landscape of female-led companies in Wales for 2025, highlighting trends in company activity, leadership, and sustainability. It provides an overview of
                                        key developments and regional differences.
                                    </p>
                                    <div className='actionBtnsWrap'>
                                        <Link href="/images/Narratives/2025/Wales-Report-2025.pdf" target="_blank">
                                            <button className='btn-green' onClick={() => setGAnalytics("Wales")}>Download narrative</button >
                                        </Link>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <Image
                                    src="/images/Narratives/2025/Northern-Ireland.png"
                                    alt="report_cover_image"
                                    width={295}
                                    height={414}
                                    loading="lazy"
                                />
                                <div className="reportDetail">
                                    <h2>Northern Ireland narrative 2025</h2>
                                    <p className='body-default-copy'>
                                        This report explores the state of female-led companies in Northern Ireland for 2025, focusing on trends in company formation, leadership, and closures. It offers insights into
                                        regional dynamics and broader patterns.
                                    </p>
                                    <div className='actionBtnsWrap'>
                                        <Link href="/images/Narratives/2025/Northern-Ireland-Report-2025.pdf" target="_blank">
                                            <button className='btn-green' onClick={() => setGAnalytics("Northern Ireland")}>Download narrative</button >
                                        </Link>
                                    </div>
                                </div>
                            </li>
                            {/* 2024 Narrative */}
                            <li>
                                <Image
                                    src="/images/Narratives/2024/England.jpg"
                                    alt="report_cover_image"
                                    width={295}
                                    height={414}
                                    loading="lazy"
                                />
                                <div className="reportDetail">
                                    <h2>England narrative 2024</h2>
                                    <p className='body-default-copy'>
                                        In this report we provide an overview of information from The Gender Index across 2023 with a
                                        focus on England. The period covered by this report was therefore shaped by anaemic national
                                        economic growth, sharp increases in prices and costs, high interest rates and, for some companies,
                                        on-going issues with staff recruitment and retention.
                                    </p>
                                    <div className='actionBtnsWrap'>
                                        <Link href="/images/Narratives/2024/England-Report-2024.pdf" target="_blank">
                                            <button className='btn-green' onClick={() => setGAnalytics("England")}>Download narrative</button >
                                        </Link>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <Image
                                    src="/images/Narratives/2024/Scotland.jpg"
                                    alt="report_cover_image"
                                    width={295}
                                    height={414}
                                    loading="lazy"
                                />
                                <div className="reportDetail">
                                    <h2>Scotland narrative 2024</h2>
                                    <p className='body-default-copy'>
                                        In 2023, 20.3% of all new incorporations in Scotland were female-led, similar to the share of new incorporations in 2022 which stood at 20.6%. New
                                        incorporations led by mixed-gender teams accounted for 11.4% of all incorporations, suggesting a female business leadership participation rate of around
                                        33% among newly incorporated companies.
                                    </p>
                                    <div className='actionBtnsWrap'>
                                        <Link href="/images/Narratives/2024/Scotland-Report-2024.pdf" target="_blank">
                                            <button className='btn-green' onClick={() => setGAnalytics("Scotland")}>Download narrative</button >
                                        </Link>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <Image
                                    src="/images/Narratives/2024/Wales.jpg"
                                    alt="report_cover_image"
                                    width={295}
                                    height={414}
                                    loading="lazy"
                                />
                                <div className="reportDetail">
                                    <h2>Wales narrative 2024</h2>
                                    <p className='body-default-copy'>
                                        Companies in Wales faced challenging economic head winds in 2023, especially small- and medium-sized companies which make up the vast majority.
                                        These have resulted from economic slowdown, high energy prices and the impact of austerity and inflation on consumer spending. As a result, the number
                                        of newly incorporated companies in Wales fell back slightly from the 2022 total.
                                    </p>
                                    <div className='actionBtnsWrap'>
                                        <Link href="/images/Narratives/2024/Wales-Report-2024.pdf" target="_blank">
                                            <button className='btn-green' onClick={() => setGAnalytics("Wales")}>Download narrative</button >
                                        </Link>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <Image
                                    src="/images/Narratives/2024/Northern-Ireland.jpg"
                                    alt="report_cover_image"
                                    width={295}
                                    height={414}
                                    loading="lazy"
                                />
                                <div className="reportDetail">
                                    <h2>Northern Ireland narrative 2024</h2>
                                    <p className='body-default-copy'>
                                        Across the UK, 21.2% of newly incorporated companies in 2023 were female-led. Northern Ireland remained the poorest performing ITL 1 region alongside
                                        the North East, each with 19.3% of newly incorporated companies being female-led.
                                    </p>
                                    <div className='actionBtnsWrap'>
                                        <Link href="/images/Narratives/2024/Northern-Ireland-Report-2024.pdf" target="_blank">
                                            <button className='btn-green' onClick={() => setGAnalytics("Northern Ireland")}>Download narrative</button >
                                        </Link>
                                    </div>
                                </div>
                            </li>
                            {/* 2023 Narrative */}
                            <li>
                                {/* <img src="/images/Narratives/2023/England.png" alt="report_cover_image" /> */}
                                <Image
                                    src="/images/Narratives/2023/England.png"
                                    alt="report_cover_image"
                                    width={295}
                                    height={414}
                                    loading="lazy"
                                />
                                <div className="reportDetail">
                                    <h2>England narrative 2023</h2>
                                    <p className='body-default-copy'>In 2023, the Gender Index suggests there were 714,000 active female-led companies in England. This
                                        represents a female-led share of all active companies of 17.4% overall, a slight increase from 16.9% in 2022.</p>
                                    <div className='actionBtnsWrap'>
                                        <Link href="/images/Narratives/2023/England-2023.pdf" target="_blank">
                                            <button className='btn-green' onClick={() => setGAnalytics("England")}>Download narrative</button >
                                        </Link>
                                    </div>
                                </div>
                            </li>
                            <li>
                                {/* <img src="/images/Narratives/2023/Scottish.png" alt="report_cover_image" /> */}
                                <Image
                                    src="/images/Narratives/2023/Scottish.png"
                                    alt="report_cover_image"
                                    width={295}
                                    height={414}
                                    loading="lazy"
                                />
                                <div className="reportDetail">
                                    <h2>Scotland narrative 2023</h2>
                                    <p className='body-default-copy'>For 2022/3, 19.4% of all incorporations in Scotland were female-led accounting for 4.2% of all
                                        UK female-led incorporations and just under 1% of all UK incorporations.</p>
                                    <div className='actionBtnsWrap'>
                                        <Link href="/images/Narratives/2023/Scotland 2023.pdf" target="_blank">
                                            <button className='btn-green' onClick={() => setGAnalytics("Scotland")}>Download narrative</button >
                                        </Link>
                                    </div>
                                </div>
                            </li>
                            <li>
                                {/* <img src="/images/Narratives/2023/Wales.png" alt="report_cover_image" /> */}
                                <Image
                                    src="/images/Narratives/2023/Wales.png"
                                    alt="report_cover_image"
                                    width={295}
                                    height={414}
                                    loading="lazy"
                                />
                                <div className="reportDetail">
                                    <h2>Wales narrative 2023</h2>
                                    <p className='body-default-copy'>The Gender Index shows that in Wales in 2023 there were 22,900 active female-led companies. This is a share of 16.7% of active companies in Wales, slightly below the rate of 17.2% (16.5%) across the rest of UK. Wales has improved from 16.5% in 2022.</p>
                                    <div className='actionBtnsWrap'>
                                        <Link href="/images/Narratives/2023/Wales-2023.pdf" target="_blank">
                                            <button className='btn-green' onClick={() => setGAnalytics("Wales")}>Download narrative</button >
                                        </Link>
                                    </div>
                                </div>
                            </li>
                            <li>
                                {/* <img src="/images/Narratives/2023/NI.png" alt="report_cover_image" /> */}
                                <Image
                                    src="/images/Narratives/2023/NI.png"
                                    alt="report_cover_image"
                                    width={295}
                                    height={414}
                                    loading="lazy"
                                />
                                <div className="reportDetail">
                                    <h2>Northern Ireland narrative 2023</h2>
                                    <p className='body-default-copy'>In 2023, The Gender Index suggests there were 67,388 companies in Northern Ireland,
                                        equivalent to 1.48% of all UK companies and representing an increase of 2,621 companies over the previous 12 months. As such, Northern Ireland was one of the few UK regions to
                                        experience a growth in the stock of companies over the year.</p>
                                    <div className='actionBtnsWrap'>
                                        <Link href="/images/Narratives/2023/Northern-Ireland-2023.pdf" target="_blank">
                                            <button className='btn-green' onClick={() => setGAnalytics("Northern Ireland")}>Download narrative</button >
                                        </Link>
                                    </div>
                                </div>
                            </li>
                            {/* 2022 Narrative */}
                            <li>
                                {/* <img src="/images/Narratives/2022/England.jpg" alt="report_cover_image" /> */}
                                <Image
                                    src="/images/Narratives/2022/England.jpg"
                                    alt="report_cover_image"
                                    width={295}
                                    height={414}
                                    loading="lazy"
                                />
                                <div className="reportDetail">
                                    <h2>England narrative 2022 </h2>
                                    <p className='body-default-copy'>The Rose Review of Female Entrepreneurship (2019) and the continuing work of the Rose Review Board and the Investing in Women Council has focused the attention of policy makers across England on womens’ enterprise.</p>
                                    <div className='actionBtnsWrap'>
                                        <Link href="/images/Narratives/2022/The-Gender-Index-England.pdf" target="_blank">
                                            <button className='btn-green' onClick={() => setGAnalytics("Download Narrative Report - England 2022")}>Download narrative</button >
                                        </Link>
                                    </div>
                                </div>
                            </li>
                            <li>
                                {/* <img src="/images/Narratives/2022/Scotland.jpg" alt="report_cover_image" /> */}
                                <Image
                                    src="/images/Narratives/2022/Scotland.jpg"
                                    alt="report_cover_image"
                                    width={295}
                                    height={414}
                                    loading="lazy"
                                />
                                <div className="reportDetail">
                                    <h2>Scotland narrative 2022</h2>
                                    <p className='body-default-copy'>This section of the report will provide an analysis of Scottish businesses as indicated in The Gender Index dataset (2022). The Gender Index examined the leadership of 4.4 million businesses across the U.K., illustrating that as of January 2022, 16.8% of firms were stated to be female–led as compared to: male–led (60.3%), mixed (16.5%) and uncertain/undeterminable (6.4%). For Scotland, the average number of female–led businesses is 15.4%, which is slightly below the U.K. average.</p>
                                    <div className='actionBtnsWrap'>
                                        <Link href="/images/Narratives/2022/The-Gender-Index-Scotland.pdf" target="_blank">
                                            <button className='btn-green' onClick={() => setGAnalytics("Scotland 2022")}>Download narrative</button >
                                        </Link>
                                    </div>
                                </div>
                            </li>
                            <li>
                                {/* <img src="/images/Narratives/2022/Wales.jpg" alt="report_cover_image" /> */}
                                <Image
                                    src="/images/Narratives/2022/Wales.jpg"
                                    alt="report_cover_image"
                                    width={295}
                                    height={414}
                                    loading="lazy"
                                />
                                <div className="reportDetail">
                                    <h2>Wales narrative 2022</h2>
                                    <p className='body-default-copy'>This report presents key findings for Wales from analysis of The Gender Index data on women business leadership in Wales. UK Office for National Statistics business demography statistics show that 99.4% of businesses in Wales in 2019 were SMEs (250 or fewer employees), with SMEs contributing 38% of private sector business turnover and 62% of employment in Wales. Improving inclusivity in entrepreneurship has been a policy priority for Wales for over two decades.</p>
                                    <div className='actionBtnsWrap'>
                                        <Link href="/images/Narratives/2022/The-Gender-Index-Wales.pdf" target="_blank">
                                            <button className='btn-green' onClick={() => setGAnalytics("Wales 2022")}>Download narrative</button >
                                        </Link>
                                    </div>
                                </div>
                            </li>
                            <li>
                                {/* <img src="/images/Narratives/2022/NI.jpg" alt="report_cover_image" /> */}
                                <Image
                                    src="/images/Narratives/2022/NI.jpg"
                                    alt="report_cover_image"
                                    width={295}
                                    height={414}
                                    loading="lazy"
                                />
                                <div className="reportDetail">
                                    <h2>Northern Ireland narrative 2022</h2>
                                    <p className='body-default-copy'>The Gender Index provides the first comprehensive analysis of gender–leadership of companies across the UK. The period covered by this report includes the 12–months from February 2021 to January 2022. During this period, an active population of 4,411,842 UK companies was recorded, with 64,767 (1.46 %) of these in Northern Ireland. Northern Ireland, like other parts of the UK is dominated by micro–companies (less than 10 employees) accounting for 57,237 or 88.3% of all companies, with only 7,530 (11.6%) with 10 or more employees.</p>
                                    <div className='actionBtnsWrap'>
                                        <Link href="/images/Narratives/2022/The-Gender-Index-Northern-Ireland.pdf" target="_blank">
                                            <button className='btn-green' onClick={() => setGAnalytics("Northern Ireland 2022")}>Download narrative</button >
                                        </Link>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </Layout>
        </div>
    );
}

